<template>
    <div>
        <o-field label="Job # *" :type="fieldType('dob_job_number')" :message="getError('dob_job_number')">
            <o-input placeholder="Job #" v-model="form.dob_job_number"/>
        </o-field>

        <o-field label="Doc # *" :type="fieldType('doc_number')" :message="getError('doc_number')">
            <o-input placeholder="Doc #" v-model="form.doc_number"/>
        </o-field>

        <o-field label="Applicant *" :type="fieldType('applicant_id')" :message="getError('applicant_id')">
            <o-select placeholder="Select an applicant" v-model="form.applicant_id" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="applicant in applicants"
                    :value="applicant.id"
                    :key="applicant.id">
                    {{ applicant.full_name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Site Contact *" :type="fieldType('on_site_contact_id')" :message="getError('on_site_contact_id')">
            <o-select placeholder="Select a Contact" v-model="form.on_site_contact_id" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="applicant in applicants"
                    :value="applicant.id"
                    :key="applicant.id">
                    {{ applicant.full_name }}
                </option>
            </o-select>
        </o-field>

        <o-field label="Days Requested *" :type="fieldType('days_requested')" :message="getError('days_requested')">
            <o-input placeholder="Days Requested" v-model="form.days_requested"/>
        </o-field>

        <o-field label="Status *" :type="fieldType('status')" :message="getError('status')">
            <o-select placeholder="Select a status" v-model="form.status" expanded>
                <option :value="null">Not Specified</option>
                <option
                    v-for="status in afterHoursPermitStatuses"
                    :value="status.id"
                    :key="status.id">
                    {{ status.name }}
                </option>
            </o-select>
        </o-field>
    </div>
</template>

<script>
    import Application from '../../../mixins/Application'
    import HandlesForm from '../../../mixins/HandlesForm'
    import { mapGetters } from 'vuex'

    export default {
        mixins: [Application, HandlesForm],

        data () {
            return {
                form: {
                    on_site_contact_id: null,
                    days_requested: null,
                    dob_job_number: null,
                    applicant_id: null,
                    doc_number: null,
                    status: null
                }
            }
        },

        computed: {
            ...mapGetters({
                afterHoursPermitStatuses: 'afterHoursPermitStatuses',
                applicants: 'contacts'
            })
        }
    }
</script>
